import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ms-snow-animation',
  templateUrl: './snow-animation.component.html',
  styleUrls: ['./snow-animation.component.scss'],
  standalone: false
})
export class SnowAnimationComponent implements OnInit, OnChanges {
  @Input() enabled: boolean = true;
  @Input() snowflakeCount: number = 100;
  @Input() speed: 'slow' | 'medium' | 'fast' = 'medium';

  snowflakes: Array<{
    left: number;
    animationDuration: number;
    animationDelay: number;
    size: number;
    opacity: number;
    symbol: string;
  }> = [];

  private snowflakeSymbols = ['❄', '❅', '❆', '✻', '✼', '✽', '✾', '✿', '❀', '❁'];

  private speedMap = {
    slow: { min: 10, max: 15 },
    medium: { min: 5, max: 10 },
    fast: { min: 3, max: 5 }
  };

  ngOnInit() {
    this.updateSnowflakes();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Отслеживаем изменения enabled, snowflakeCount и speed
    if (changes['enabled'] || changes['snowflakeCount'] || changes['speed']) {
      this.updateSnowflakes();
    }
  }

  private updateSnowflakes() {
    // Очищаем существующие снежинки
    this.snowflakes = [];

    if (this.enabled) {
      // Автоматическая оптимизация для слабых устройств
      const optimizedCount = this.getOptimizedSnowflakeCount();
      this.snowflakeCount = optimizedCount < this.snowflakeCount ? optimizedCount : this.snowflakeCount;
      this.generateSnowflakes();
    }
  }

  /**
   * Определяет оптимальное количество снежинок на основе производительности устройства
   */
  private getOptimizedSnowflakeCount(): number {
    // Проверяем наличие hardwareConcurrency (количество ядер CPU)
    const cores = navigator.hardwareConcurrency || 4;

    // Проверяем наличие deviceMemory (объем памяти устройства)
    const memory = (navigator as any).deviceMemory || 4;

    // Проверяем, является ли устройство мобильным
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // Уменьшаем количество снежинок на слабых устройствах
    if (isMobile) {
      // На мобильных устройствах используем меньше снежинок
      return Math.min(this.snowflakeCount, cores < 4 || memory < 4 ? 30 : 50);
    }

    // На десктопе можно использовать больше, но все равно ограничиваем
    return cores < 4 || memory < 4 ? 50 : this.snowflakeCount;
  }

  trackByIndex(index: number): number {
    return index;
  }

  private generateSnowflakes() {
    const speedRange = this.speedMap[this.speed];
    const maxDuration = speedRange.max;

    for (let i = 0; i < this.snowflakeCount; i++) {
      const animationDuration = Math.random() * (speedRange.max - speedRange.min) + speedRange.min;
      // Распределяем задержки по всему циклу анимации для непрерывного потока
      // Задержка может быть от 0 до максимальной длительности, чтобы снежинки появлялись постоянно
      const animationDelay = Math.random() * maxDuration;

      this.snowflakes.push({
        left: Math.random() * 100,
        animationDuration,
        animationDelay,
        size: Math.random() * 12 + 10,
        opacity: Math.random() * 0.5 + 0.5,
        symbol: this.snowflakeSymbols[Math.floor(Math.random() * this.snowflakeSymbols.length)]
      });
    }
  }
}

